import React from 'react';
import { FormulaComponentProps } from '../../types/index';
import { MathMLRenderer, createMathML } from '../shared/MathMLRenderer';

export const EvidenceIndex: React.FC<FormulaComponentProps> = ({ className, style }) => {
  const evidenceIndexFormula = createMathML(`
    <mrow>
      <mi>EI</mi>
      <mo>=</mo>
      <mfrac>
        <msub>
          <mi>N</mi>
          <msub>
            <mi>pubs</mi>
            <mo>+</mo>
          </msub>
        </msub>
        <msub>
          <mi>N</mi>
          <msub>
            <mi>pubs</mi>
            <mi>total</mi>
          </msub>
        </msub>
      </mfrac>
    </mrow>
  `);

  return (
    <div className={className} style={style}>
      <MathMLRenderer mathML={evidenceIndexFormula} />
    </div>
  );
};